import { render, staticRenderFns } from "./PART_INFO.vue?vue&type=template&id=c87855ae&scoped=true&"
import script from "./PART_INFO.vue?vue&type=script&lang=js&"
export * from "./PART_INFO.vue?vue&type=script&lang=js&"
import style0 from "./PART_INFO.vue?vue&type=style&index=0&id=c87855ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87855ae",
  null
  
)

export default component.exports